
import { Component, Vue } from "vue-property-decorator";

interface KiraForm {
  mevcutKira: number | null;
  artisOrani: number | null;
}

@Component
export default class KiraArtisHesaplayici extends Vue {
  form: KiraForm = { mevcutKira: null, artisOrani: null };
  sonuc: number | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  get formGecerli(): boolean {
    return (
        this.form.mevcutKira !== null &&
        this.form.mevcutKira >= 0 &&
        this.form.artisOrani !== null
    );
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/kira-artis",
          {
            mevcut_kira: this.form.mevcutKira,
            artis_orani: this.form.artisOrani,
          }
      );

      const data = response.data || response;
      this.sonuc = data.yeni_kira;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
